package com.zaurh.mapquizwebsite

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.zaurh.mapquizwebsite.di.appModule
import com.zaurh.mapquizwebsite.presentation.screen.main.App
import org.koin.core.context.startKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    startKoin {
        modules(appModule)
    }
    ComposeViewport {
        App()
    }
}